/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '@ng-bootstrap/ng-bootstrap/typeahead/highlight';
const styles_NgbHighlight:any[] = ['.ngb-highlight[_ngcontent-%COMP%] {\n      font-weight: bold;\n    }'];
export const RenderType_NgbHighlight:i0.RendererType2 = i0.ɵcrt({encapsulation:0,styles:styles_NgbHighlight,
    data:{}});
function View_NgbHighlight_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),
      [[8,'className',0]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i0.ɵinlineInterpolate(1,'',_co.highlightClass,'');
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = (<any>_v.parent).context.$implicit;
    _ck(_v,1,0,currVal_1);
  });
}
function View_NgbHighlight_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit;
    _ck(_v,0,0,currVal_0);
  });
}
function View_NgbHighlight_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_NgbHighlight_2)),i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,
      i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵand(16777216,(null as any),
      (null as any),1,(null as any),View_NgbHighlight_3)),i0.ɵdid(16384,(null as any),
      0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵand(0,(null as any),(null as any),0))],(_ck,_v) => {
    const currVal_0:any = _v.context.odd;
    _ck(_v,1,0,currVal_0);
    const currVal_1:boolean = !_v.context.odd;
    _ck(_v,3,0,currVal_1);
  },(null as any));
}
export function View_NgbHighlight_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(2,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_NgbHighlight_1)),i0.ɵdid(802816,(null as any),0,i1.NgForOf,[i0.ViewContainerRef,
      i0.TemplateRef,i0.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any))],(_ck,
      _v) => {
    var _co:i2.NgbHighlight = _v.component;
    const currVal_0:any = _co.parts;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_NgbHighlight_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'ngb-highlight',
      ([] as any[]),(null as any),(null as any),(null as any),View_NgbHighlight_0,
      RenderType_NgbHighlight)),i0.ɵdid(573440,(null as any),0,i2.NgbHighlight,([] as any[]),
      (null as any),(null as any))],(null as any),(null as any));
}
export const NgbHighlightNgFactory:i0.ComponentFactory<i2.NgbHighlight> = i0.ɵccf('ngb-highlight',
    i2.NgbHighlight,View_NgbHighlight_Host_0,{highlightClass:'highlightClass',result:'result',
        term:'term'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9saWIvamVua2lucy93b3Jrc3BhY2UvdmVueW91LXN0cmlwZS9ub2RlX21vZHVsZXMvQG5nLWJvb3RzdHJhcC9uZy1ib290c3RyYXAvdHlwZWFoZWFkL2hpZ2hsaWdodC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvbGliL2plbmtpbnMvd29ya3NwYWNlL3ZlbnlvdS1zdHJpcGUvbm9kZV9tb2R1bGVzL0BuZy1ib290c3RyYXAvbmctYm9vdHN0cmFwL3R5cGVhaGVhZC9oaWdobGlnaHQuZC50cyIsIm5nOi8vL3Zhci9saWIvamVua2lucy93b3Jrc3BhY2UvdmVueW91LXN0cmlwZS9ub2RlX21vZHVsZXMvQG5nLWJvb3RzdHJhcC9uZy1ib290c3RyYXAvdHlwZWFoZWFkL2hpZ2hsaWdodC5kLnRzLk5nYkhpZ2hsaWdodC5odG1sIiwibmc6Ly8vdmFyL2xpYi9qZW5raW5zL3dvcmtzcGFjZS92ZW55b3Utc3RyaXBlL25vZGVfbW9kdWxlcy9AbmctYm9vdHN0cmFwL25nLWJvb3RzdHJhcC90eXBlYWhlYWQvaGlnaGxpZ2h0LmQudHMuTmdiSGlnaGxpZ2h0X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPG5nLXRlbXBsYXRlIG5nRm9yIFtuZ0Zvck9mXT1cInBhcnRzXCIgbGV0LXBhcnQgbGV0LWlzT2RkPVwib2RkXCI+PHNwYW4gKm5nSWY9XCJpc09kZFwiIGNsYXNzPVwie3toaWdobGlnaHRDbGFzc319XCI+e3twYXJ0fX08L3NwYW4+PG5nLXRlbXBsYXRlIFtuZ0lmXT1cIiFpc09kZFwiPnt7cGFydH19PC9uZy10ZW1wbGF0ZT48L25nLXRlbXBsYXRlPiIsIjxuZ2ItaGlnaGxpZ2h0PjwvbmdiLWhpZ2hsaWdodD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7b0JDQThEO01BQUE7TUFBK0M7O0lBQTNCO0lBQXBCLFdBQW9CLFNBQXBCO0lBQStDO0lBQUE7Ozs7b0JBQTRDO0lBQUE7SUFBQTs7OztvQkFBM0Y7TUFBQSw2QkFBQTtvQkFBQSxtQ0FBOEQ7TUFBQSwyREFBQTtNQUFBOztJQUF4RDtJQUFOLFdBQU0sU0FBTjtJQUEyRTtJQUFiLFdBQWEsU0FBYjs7OztvQkFBNUg7TUFBQSw2QkFBQTt1Q0FBQTs7O0lBQW1CO0lBQW5CLFdBQW1CLFNBQW5COzs7O29CQ0FBO01BQUE7NkJBQUEsVUFBQTtNQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/venyou-stripe/src/$$_gendir/~/@ng-bootstrap/ng-bootstrap/typeahead/highlight.ngfactory.ts